"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class UserCarrierAccounts {
}
exports.UserCarrierAccounts = UserCarrierAccounts;
//# sourceMappingURL=UserCarrierAccounts.js.map